import { useEffect } from 'react'
import Lightbox from 'yet-another-react-lightbox'
import 'yet-another-react-lightbox/styles.css'

export default function ArtworkLightbox({ artwork, isOpen, onClose, allArtworks, onNavigate }) {
  // Handle keyboard navigation
  useEffect(() => {
    if (!isOpen) return

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose()
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [isOpen, onClose])

  if (!artwork) return null

  // Prepare slides from all images of the selected artwork
  const slides = artwork.images.map((image, index) => ({
    src: image.full,
    alt: `${artwork.title}${index > 0 ? ` (Bild ${index + 1})` : ''}`,
    width: 1600,
    height: 1600,
  }))

  return (
    <>
      <Lightbox
        open={isOpen}
        close={onClose}
        slides={slides}
        index={0}
        animation={{ fade: 300 }}
        controller={{ closeOnBackdropClick: true, swipeDistance: slides.length <= 1 ? Infinity : 100 }}
        carousel={{ finite: slides.length <= 1 }}
        render={{
          buttonPrev: slides.length <= 1 ? () => null : undefined,
          buttonNext: slides.length <= 1 ? () => null : undefined,
          // Custom slide content with artwork details
          slide: ({ slide }) => {
            const currentIndex = slides.findIndex(s => s.src === slide.src)
            return (
              <div className="flex flex-col items-center justify-center h-full px-8 py-6">
                <img
                  src={slide.src}
                  alt={slide.alt}
                  className="max-w-full max-h-[55vh] object-contain rounded-sm shadow-lg"
                />
                <div className="mt-6 text-center text-white bg-black/50 px-6 py-4 rounded-lg">
                  <h3 className="text-2xl font-serif mb-2">{artwork.title}</h3>
                  <div className="text-sm space-y-1">
                    <p>{artwork.year} · {artwork.medium}</p>
                    <p>
                      {artwork.dimensions.width} × {artwork.dimensions.height} cm
                    </p>
                    {artwork.description && (
                      <p className="mt-3 text-neutral-200 max-w-2xl">
                        {artwork.description}
                      </p>
                    )}
                    {artwork.images.length > 1 && (
                      <p className="mt-2 text-xs text-neutral-300">
                        Bild {currentIndex + 1} von {artwork.images.length}
                      </p>
                    )}
                  </div>
                  {artwork.poem && (
                    <p className="mt-6 text-neutral-300 max-w-2xl font-serif italic text-sm leading-relaxed whitespace-pre-line">
                      {artwork.poem}
                    </p>
                  )}
                </div>
              </div>
            )
          }
        }}
      />
    </>
  )
}
